/**
 * Plazos orientativos del marketplace (días laborables, sin fines de semana ni festivos).
 * Referencia contractual: docs/compliance/legal/terminos_condiciones.md §5.1
 * y docs/appendix/SDD_Addendum_Partner.md § Plazos operativos.
 */
export const MARKETPLACE_SLA = {
  /** Vendedor entrega el disco al partner (tienda o punto). */
  sellerToPartner: { min: 2, max: 3 },
  /** Partner recibe y verifica / prepara en tienda verificadora. */
  partnerStoreVerification: { min: 2, max: 3 },
  /** Partner recibe paquete en punto DreamVinyl. */
  partnerPickupReceive: { min: 2, max: 3 },
  /** Partner envía al comprador (modo ship_to_buyer). */
  partnerOutboundToBuyer: { min: 2, max: 3 },
  /** Vendedor envía directo al comprador (sin partner). */
  directSellerShip: { min: 2, max: 5 },
};

export function businessDaysLabel({ min, max }) {
  const a = Number(min);
  const b = Number(max);
  if (!Number.isFinite(a) || !Number.isFinite(b)) return '—';
  if (a === b) return a === 1 ? '1 día laborable' : `${a} días laborables`;
  return `${a}–${b} días laborables`;
}

/** Texto único para pasos del timeline de pedido (mismo copy en todos los pasos). */
export function slaOrderStepHint(sla) {
  return `Plazo orientativo: ${businessDaysLabel(sla)}. Días laborables (lunes a viernes); no cuentan fines de semana ni festivos.`;
}

/** @deprecated Usar slaOrderStepHint */
export function slaActiveStepHint(sla) {
  return slaOrderStepHint(sla);
}

/** @deprecated Usar slaOrderStepHint */
export function slaPendingStepHint(sla) {
  return slaOrderStepHint(sla);
}

/** Obligación para vendedor/partner (normas). */
export function slaObligationHint(role, sla) {
  const who = role === 'partner' ? 'El partner' : 'El vendedor';
  return `${who} debe cumplir en un máximo de ${businessDaysLabel(sla)} desde que corresponda actuar.`;
}
